import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type LensCloudApp } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { lensCloudApp } from "../api/queries/lensCloudApp";
import { type LensCloudAppQuery, type LensCloudAppQueryVariables } from "../api/queries/lensCloudApp.gql-generated";

interface UseLensCloudAppParams {
    lensId: string;
}

export const useLensCloudApp = ({ lensId }: UseLensCloudAppParams): ApolloResult<LensCloudApp> => {
    const { data, loading, error } = useQuery<LensCloudAppQuery, LensCloudAppQueryVariables>(lensCloudApp, {
        skip: !lensId,
        variables: {
            lensId,
        },
    });

    return useMemo(() => {
        return {
            loading,
            error,
            appId: data?.lensCloudApp.appId ?? "",
        };
    }, [loading, error, data]);
};
